module.exports = __webpack_public_path__ + "static/img/10.c42b43f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/zh/10.png
// module id = 8muM
// module chunks = 0